module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Room Settings":"Room Settings","Room Name":"Room Name","Please input Room Name":"Please input Room Name","Enter a room name.":"Enter a room name."},"zh":{"Room Settings":"直播间设置","Room Name":"昵称设置","Please input Room Name":"请输入直播间名字","Enter a room name.":"直播间名称不能为空!"}}')
  delete Component.options._Ctor
}
